var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "tw-contents"
  }, [!_vm.sourceDoctor ? _c('div', {
    staticClass: "tw-flex tw-items-center tw-justify-center tw-px-4 tw-text-center",
    staticStyle: {
      "grid-area": "configs"
    }
  }, [_c('span', {
    staticClass: "text-muted text-small"
  }, [_vm._v(" Select a source doctor to see the proposed distribution. ")])]) : !_vm.selectedStates.length ? _c('div', {
    staticClass: "tw-flex tw-items-center tw-justify-center tw-px-4 tw-text-center",
    staticStyle: {
      "grid-area": "configs"
    }
  }, [_c('span', {
    staticClass: "text-muted text-small"
  }, [_vm._v(" Select a state to load doctors. ")])]) : _vm.loading ? _c('div', {
    staticClass: "tw-flex tw-items-center tw-justify-center",
    staticStyle: {
      "grid-area": "configs"
    }
  }, [_c('IconLoading', {
    staticClass: "tw-size-5 tw-text-primary"
  }), _c('span', {
    staticClass: "text-muted text-small tw-ml-2"
  }, [_vm._v("Loading doctors…")])], 1) : !_vm.doctors.length ? _c('div', {
    staticClass: "tw-flex tw-items-center tw-justify-center tw-px-4 tw-text-center",
    staticStyle: {
      "grid-area": "configs"
    }
  }, [_c('span', {
    staticClass: "text-muted text-small"
  }, [_vm._v(" No doctors are licensed in the selected states. Try widening your state selection. ")])]) : [_c('div', {
    staticClass: "tw-h-full tw-overflow-y-auto tw-border-gray-200 tw-pb-4",
    staticStyle: {
      "grid-area": "configs"
    }
  }, [_c('div', {
    staticClass: "tw-grid tw-grid-cols-2 tw-gap-4"
  }, [_c('div', {
    staticClass: "tw-rounded tw-border tw-border-gray-200 tw-bg-gray-50 tw-p-4"
  }, [_c('label', {
    staticClass: "text-primary text-small tw-mb-1 tw-block"
  }, [_vm._v(" Include patients "), _vm.includePatients === 'ACTIVE' ? [_vm._v(" (" + _vm._s(_vm.includePatientsCounts.active) + " Active) ")] : [_vm._v(" (" + _vm._s(_vm.includePatientsCounts.total) + " Total · " + _vm._s(_vm.includePatientsCounts.active) + " Active · " + _vm._s(_vm.includePatientsCounts.cancelled) + " Cancelled) ")]], 2), _c('div', {
    staticClass: "tw-flex tw-gap-4"
  }, [_c('b-form-radio', {
    attrs: {
      "value": "ALL"
    },
    model: {
      value: _vm.includePatients,
      callback: function ($$v) {
        _vm.includePatients = $$v;
      },
      expression: "includePatients"
    }
  }, [_vm._v(" All ")]), _c('b-form-radio', {
    attrs: {
      "value": "ACTIVE"
    },
    model: {
      value: _vm.includePatients,
      callback: function ($$v) {
        _vm.includePatients = $$v;
      },
      expression: "includePatients"
    }
  }, [_vm._v(" Active only ")])], 1), _c('div', {
    staticClass: "text-muted text-small tw-mt-1"
  }, [_vm._v(_vm._s(_vm.includeCaption))]), _c('div', {
    staticClass: "text-small tw-mt-2"
  }, [_c('strong', [_vm._v(_vm._s(_vm.ownedCoveringCounts.owned))]), _vm._v(" owned · "), _c('strong', [_vm._v(_vm._s(_vm.ownedCoveringCounts.covering))]), _vm._v(" covering ")]), _c('hr', {
    staticClass: "tw-my-4 tw-border-gray-200"
  }), _c('label', {
    staticClass: "text-primary text-small tw-mb-1 tw-block"
  }, [_vm._v("Reduce by")]), _c('div', {
    staticClass: "tw-mb-2 tw-flex tw-gap-4"
  }, [_c('b-form-radio', {
    attrs: {
      "value": "COUNT"
    },
    model: {
      value: _vm.reduceByMode,
      callback: function ($$v) {
        _vm.reduceByMode = $$v;
      },
      expression: "reduceByMode"
    }
  }, [_vm._v(" Number of patients ")]), _c('b-form-radio', {
    attrs: {
      "value": "PERCENT"
    },
    model: {
      value: _vm.reduceByMode,
      callback: function ($$v) {
        _vm.reduceByMode = $$v;
      },
      expression: "reduceByMode"
    }
  }, [_vm._v(" Percent of panel ")])], 1), _c('div', {
    staticClass: "tw-flex tw-items-center tw-gap-2"
  }, [_c('b-form-input', {
    staticStyle: {
      "width": "140px"
    },
    attrs: {
      "type": "number",
      "min": "0",
      "value": _vm.reduceByAmount
    },
    on: {
      "input": _vm.onReduceAmountInput
    }
  }), _c('span', {
    staticClass: "text-small"
  }, [_vm._v("patients")]), _c('span', {
    staticClass: "text-muted text-small"
  }, [_vm._v(_vm._s(_vm.reduceCaption))])], 1), _c('div', {
    staticClass: "text-muted text-small tw-mt-1"
  }, [_vm._v(" Auto-fills from your state selection. Edit to override. ")])]), _c('div', {
    staticClass: "tw-rounded tw-border tw-border-gray-200 tw-bg-gray-50 tw-p-4"
  }, [_c('b-form-checkbox', {
    model: {
      value: _vm.weightByLoad,
      callback: function ($$v) {
        _vm.weightByLoad = $$v;
      },
      expression: "weightByLoad"
    }
  }, [_vm._v(" Weight distribution by current load ")]), _c('div', {
    staticClass: "text-muted text-small tw-mt-1"
  }, [_vm._v(" Distributes more patients to doctors with lower current load. When off, all checked doctors split evenly. ")])], 1)])]), _c('div', {
    staticClass: "tw-flex tw-min-h-0 tw-flex-col",
    staticStyle: {
      "grid-area": "table"
    }
  }, [_c('div', {
    staticClass: "tw-mb-3 tw-flex tw-shrink-0 tw-gap-3"
  }, [_c('b-input-group', {
    staticClass: "tw-flex-1"
  }, [_c('b-input-group-prepend', [_c('b-input-group-text', [_c('b-icon-search', {
    staticClass: "tw-text-eclipse"
  })], 1)], 1), _c('b-form-input', {
    staticClass: "grow-1 tw-p-0",
    attrs: {
      "placeholder": "Search doctors...",
      "type": "search",
      "autocomplete": "off"
    },
    model: {
      value: _vm.doctorSearch,
      callback: function ($$v) {
        _vm.doctorSearch = $$v;
      },
      expression: "doctorSearch"
    }
  }), _vm.doctorSearch.length > 0 ? _c('b-input-group-prepend', {
    staticClass: "p-0"
  }, [_c('b-input-group-text', {
    staticClass: "p-0"
  }, [_c('b-button', {
    staticClass: "border-0 align-self-center p-0",
    attrs: {
      "variant": "outline-white"
    },
    on: {
      "click": function ($event) {
        _vm.doctorSearch = '';
      }
    }
  }, [_c('b-icon-x-circle', {
    staticClass: "tw-text-eclipse"
  })], 1)], 1)], 1) : _vm._e()], 1), _c('b-dropdown', {
    ref: "filterDropdown",
    attrs: {
      "right": "",
      "no-caret": "",
      "variant": "outline-secondary",
      "toggle-class": "filter-toggle rounded-pill",
      "menu-class": "filter-dropdown-menu",
      "boundary": "window"
    },
    on: {
      "show": _vm.onFilterShow
    },
    scopedSlots: _vm._u([{
      key: "button-content",
      fn: function () {
        return [_c('b-icon', {
          staticClass: "mr-1",
          attrs: {
            "icon": "funnel"
          }
        }), _vm._v(" Add filter "), _vm.filters.length ? _c('b-badge', {
          staticClass: "ml-1 bg-secondary text-white",
          attrs: {
            "pill": ""
          }
        }, [_vm._v(" " + _vm._s(_vm.filters.length) + " ")]) : _vm._e()];
      },
      proxy: true
    }])
  }, [_c('b-dropdown-form', {
    staticClass: "p-4"
  }, [_vm._l(_vm.pendingFilters, function (condition, index) {
    return _c('div', {
      key: `${condition.column}-${index}`,
      staticClass: "filter-condition"
    }, [_c('b-form-select', {
      staticClass: "filter-col-column",
      attrs: {
        "options": _vm.columnOptions,
        "size": "sm"
      },
      on: {
        "change": function ($event) {
          return _vm.onColumnChange(index);
        }
      },
      model: {
        value: condition.column,
        callback: function ($$v) {
          _vm.$set(condition, "column", $$v);
        },
        expression: "condition.column"
      }
    }), _c('b-form-select', {
      staticClass: "filter-col-operator",
      attrs: {
        "options": _vm.getOperators(condition.column),
        "size": "sm"
      },
      model: {
        value: condition.operator,
        callback: function ($$v) {
          _vm.$set(condition, "operator", $$v);
        },
        expression: "condition.operator"
      }
    }), _c('div', {
      staticClass: "filter-value-wrapper",
      on: {
        "click": function ($event) {
          $event.stopPropagation();
        }
      }
    }, [_c('button', {
      staticClass: "btn btn-sm btn-outline-secondary filter-value-btn",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function ($event) {
          $event.stopPropagation();
          _vm.openDropdownIndex = _vm.openDropdownIndex === index ? null : index;
        }
      }
    }, [_c('span', {
      staticClass: "filter-value-label"
    }, [_vm._v(_vm._s(_vm.getStateSelectionLabel(condition)))]), _c('b-icon', {
      staticClass: "tw-ml-1 tw-shrink-0",
      attrs: {
        "icon": "chevron-down",
        "font-scale": "0.8"
      }
    })], 1), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: _vm.openDropdownIndex === index,
        expression: "openDropdownIndex === index"
      }],
      staticClass: "filter-state-panel",
      on: {
        "click": function ($event) {
          $event.stopPropagation();
        }
      }
    }, [_c('b-form-input', {
      staticClass: "tw-mb-2",
      attrs: {
        "size": "sm",
        "placeholder": "Search states...",
        "autocomplete": "off"
      },
      model: {
        value: condition._stateSearch,
        callback: function ($$v) {
          _vm.$set(condition, "_stateSearch", $$v);
        },
        expression: "condition._stateSearch"
      }
    }), _c('div', {
      staticClass: "filter-state-option-list"
    }, [_vm._l(_vm.getFilteredStateOptions(condition._stateSearch), function (stateOption) {
      return _c('div', {
        key: stateOption.value,
        staticClass: "filter-state-option-row",
        on: {
          "click": function ($event) {
            $event.stopPropagation();
            return _vm.toggleStateInCondition(condition, stateOption.value);
          }
        }
      }, [_c('b-form-checkbox', {
        staticClass: "tw-pointer-events-none",
        attrs: {
          "checked": (condition.value || []).includes(stateOption.value)
        }
      }), _c('span', {
        staticClass: "tw-text-xs"
      }, [_vm._v(_vm._s(stateOption.text))])], 1);
    }), !_vm.getFilteredStateOptions(condition._stateSearch).length ? _c('div', {
      staticClass: "tw-py-2 tw-text-center tw-text-xs tw-text-gray-400"
    }, [_vm._v(" No states found. ")]) : _vm._e()], 2)], 1)]), _c('b-button', {
      staticClass: "filter-remove text-muted",
      attrs: {
        "variant": "link",
        "size": "sm"
      },
      on: {
        "click": function ($event) {
          $event.stopPropagation();
          return _vm.removeCondition(index);
        }
      }
    }, [_c('b-icon', {
      attrs: {
        "icon": "x-circle"
      }
    })], 1)], 1);
  }), _vm.pendingFilters.length === 0 ? _c('p', {
    staticClass: "filter-empty-msg text-muted"
  }, [_vm._v(" No filters added yet. ")]) : _vm._e(), _c('a', {
    staticClass: "add-condition-link text-secondary",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.addCondition
    }
  }, [_vm._v(" + Add condition ")]), _c('div', {
    staticClass: "filter-footer"
  }, [_c('b-button', {
    attrs: {
      "variant": "outline-secondary",
      "size": "sm",
      "pill": ""
    },
    on: {
      "click": _vm.cancelFilter
    }
  }, [_vm._v(" Cancel ")]), _c('b-button', {
    staticClass: "apply-btn",
    attrs: {
      "variant": "primary",
      "size": "sm",
      "pill": ""
    },
    on: {
      "click": _vm.applyFilter
    }
  }, [_vm._v(" Apply ")])], 1)], 2)], 1)], 1), _vm.filters.length ? _c('div', {
    staticClass: "filter-chips tw-mb-3 tw-shrink-0"
  }, [_vm._l(_vm.filters, function (filter, index) {
    return _c('b-badge', {
      key: `${filter.column}-${filter.operator}-${String(filter.value)}-${index}`,
      staticClass: "filter-chip text-secondary",
      attrs: {
        "pill": ""
      }
    }, [_vm._v(" " + _vm._s(_vm.formatFilterChip(filter)) + " "), _c('b-icon', {
      staticClass: "ml-1 chip-remove",
      attrs: {
        "icon": "x"
      },
      on: {
        "click": function ($event) {
          return _vm.removeFilter(index);
        }
      }
    })], 1);
  }), _c('a', {
    staticClass: "clear-all-link small text-secondary",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.clearAllFilters
    }
  }, [_vm._v(" Clear all ")])], 2) : _vm._e(), _c('div', {
    staticClass: "tw-min-h-0 tw-flex-1 tw-overflow-y-auto",
    staticStyle: {
      "max-height": "420px"
    }
  }, [_c('b-table', {
    staticClass: "card-table mb-0",
    attrs: {
      "fields": _vm.tableFields,
      "items": _vm.filteredDoctors,
      "show-empty": ""
    },
    scopedSlots: _vm._u([{
      key: "empty",
      fn: function () {
        return [_c('div', {
          staticClass: "tw-flex tw-flex-col tw-items-center tw-justify-center",
          staticStyle: {
            "height": "200px"
          }
        }, [_vm.doctorSearch.trim() ? _c('span', {
          staticClass: "text-muted text-small"
        }, [_vm._v(" No doctors match \"" + _vm._s(_vm.doctorSearch.trim()) + "\". ")]) : _c('span', {
          staticClass: "text-muted text-small"
        }, [_vm._v(" No eligible covering doctors found for the selected states. ")]), _vm.filters.length ? _c('a', {
          staticClass: "text-secondary text-small tw-mt-1",
          attrs: {
            "href": "javascript:;"
          },
          on: {
            "click": _vm.clearAllFilters
          }
        }, [_vm._v(" Clear filters ")]) : _vm._e()])];
      },
      proxy: true
    }, {
      key: "head(select)",
      fn: function () {
        return [_c('b-form-checkbox', {
          attrs: {
            "checked": _vm.visibleSelectedCount > 0,
            "indeterminate": _vm.headerCheckboxState === 'indeterminate'
          },
          on: {
            "change": _vm.onHeaderCheckboxChange
          }
        })];
      },
      proxy: true
    }, {
      key: "cell(select)",
      fn: function ({
        item
      }) {
        return [_c('b-form-checkbox', {
          attrs: {
            "checked": _vm.selectedIds.includes(item.id)
          },
          on: {
            "change": function ($event) {
              return _vm.toggleDoctor(item.id);
            }
          }
        })];
      }
    }, {
      key: "cell(doctor)",
      fn: function ({
        item
      }) {
        return [_c('div', {
          staticClass: "tw-flex tw-items-center tw-gap-4"
        }, [_c('b-avatar', {
          staticClass: "tw-shrink-0",
          attrs: {
            "size": "sm",
            "text": item.firstname[0] + item.lastname[0]
          }
        }), _c('div', {
          staticClass: "tw-min-w-0 tw-flex-1"
        }, [_c('div', {
          staticClass: "tw-text-sm"
        }, [_vm._v("Dr. " + _vm._s(item.firstname) + " " + _vm._s(item.lastname))]), _c('div', {
          staticClass: "tw-mt-2 tw-flex tw-flex-wrap tw-items-center tw-gap-2"
        }, [_vm.getVisibleBadges(item).length ? _c('span', {
          staticClass: "text-muted text-small"
        }, [_vm._v(_vm._s(_vm.getVisibleBadges(item).join(', ')))]) : _vm._e(), _vm.getOverflowCount(item) > 0 ? _c('CoreTooltip', {
          attrs: {
            "placement": "bottom"
          },
          scopedSlots: _vm._u([{
            key: "popper",
            fn: function () {
              return [_c('div', {
                staticClass: "tw-mb-1 tw-font-bold"
              }, [_vm._v(" " + _vm._s(_vm.getOverflowCount(item)) + " more states ")]), _c('div', [_vm._v(_vm._s(_vm.getOverflowBadges(item).join(', ')))])];
            },
            proxy: true
          }], null, true)
        }, [_c('span', {
          staticClass: "overflow-link text-secondary tw-text-xs"
        }, [_vm._v(" +" + _vm._s(_vm.getOverflowCount(item)) + " more ")])]) : _vm._e(), _vm.selectedIds.includes(item.id) ? _c('span', {
          staticClass: "scope-pill-wrapper"
        }, [_c('button', {
          staticClass: "scope-pill",
          class: {
            'scope-pill--empty': !(_vm.doctorScopes[item.id] || []).length
          },
          attrs: {
            "type": "button"
          },
          on: {
            "click": function ($event) {
              $event.stopPropagation();
              return _vm.openScopePopover(item.id);
            }
          }
        }, [_vm._v(" " + _vm._s((_vm.doctorScopes[item.id] || []).length) + "/" + _vm._s(_vm.getRelevantStates(item).length) + " "), !(_vm.doctorScopes[item.id] || []).length ? _c('span', [_vm._v("⚠")]) : _c('b-icon', {
          staticClass: "tw-ml-1",
          attrs: {
            "icon": "chevron-down",
            "font-scale": "0.7"
          }
        })], 1), _vm.scopePopoverDoctorId === item.id ? _c('div', {
          staticClass: "scope-popover",
          on: {
            "click": function ($event) {
              $event.stopPropagation();
            }
          }
        }, [_c('div', {
          staticClass: "scope-popover-chips"
        }, _vm._l(_vm.getRelevantStates(item), function (state) {
          return _c('button', {
            key: state,
            staticClass: "scope-chip",
            class: {
              'scope-chip--active': (_vm.doctorScopes[item.id] || []).includes(state)
            },
            attrs: {
              "type": "button"
            },
            on: {
              "click": function ($event) {
                return _vm.toggleScopeState(item.id, state);
              }
            }
          }, [_vm._v(" " + _vm._s(state) + " ")]);
        }), 0), _c('div', {
          staticClass: "scope-popover-actions"
        }, [_c('a', {
          staticClass: "text-secondary text-small",
          attrs: {
            "href": "javascript:;"
          },
          on: {
            "click": function ($event) {
              return _vm.setScopeAll(item);
            }
          }
        }, [_vm._v("All")]), _c('a', {
          staticClass: "text-secondary text-small",
          attrs: {
            "href": "javascript:;"
          },
          on: {
            "click": function ($event) {
              return _vm.setScopeNone(item.id);
            }
          }
        }, [_vm._v("None")]), _c('b-button', {
          attrs: {
            "variant": "secondary",
            "size": "sm",
            "pill": ""
          },
          on: {
            "click": function ($event) {
              return _vm.closeScopePopover(item.id);
            }
          }
        }, [_vm._v(" Done ")])], 1)]) : _vm._e()]) : _vm._e()], 1)]), _vm.selectedIds.includes(item.id) ? _c('b-button', {
          staticClass: "text-muted tw-ml-2 tw-shrink-0 tw-p-0",
          attrs: {
            "variant": "link",
            "size": "sm"
          },
          on: {
            "click": function ($event) {
              $event.stopPropagation();
              return _vm.toggleRow(item);
            }
          }
        }, [_c('b-icon', {
          attrs: {
            "icon": item._showDetails ? 'chevron-up' : 'chevron-down',
            "font-scale": "0.9"
          }
        })], 1) : _vm._e()], 1)];
      }
    }, {
      key: "cell(currentLoad)",
      fn: function ({
        item
      }) {
        return [_vm.loadingLoads ? _c('IconLoading', {
          staticClass: "tw-inline tw-size-3"
        }) : _c('span', [_c('span', {
          staticClass: "tw-text-base tw-font-semibold"
        }, [_vm._v(_vm._s((_vm.doctorLoads[item.id] || 0).toLocaleString()))]), _c('span', {
          staticClass: "text-muted text-small tw-ml-1"
        }, [_vm._v("patients")])])];
      }
    }, {
      key: "cell(estimated)",
      fn: function ({
        item
      }) {
        return [_vm.selectedIds.includes(item.id) ? _c('div', {
          staticClass: "tw-flex tw-flex-col tw-items-end"
        }, [_c('div', {
          staticClass: "tw-flex tw-items-center tw-gap-1"
        }, [_c('button', {
          staticClass: "nudge-btn",
          attrs: {
            "type": "button",
            "disabled": _vm.getTotalEstimate(item.id) <= 0
          },
          on: {
            "click": function ($event) {
              return _vm.onNudge(item.id, -1);
            }
          }
        }, [_vm._v("−")]), _c('b-form-input', {
          staticClass: "nudge-input",
          attrs: {
            "type": "number",
            "min": "0",
            "size": "sm",
            "value": _vm.getTotalEstimate(item.id)
          },
          on: {
            "change": function ($event) {
              return _vm.onManualInput(item.id, $event);
            }
          }
        }), _c('button', {
          staticClass: "nudge-btn",
          attrs: {
            "type": "button",
            "disabled": _vm.totalDistributed >= _vm.reduceTargetCount
          },
          on: {
            "click": function ($event) {
              return _vm.onNudge(item.id, 1);
            }
          }
        }, [_vm._v("+")])], 1), _vm.getTotalEstimate(item.id) > 0 ? _c('div', {
          staticClass: "text-muted text-small tw-mt-1"
        }, [_vm._v(" " + _vm._s(_vm.getDoctorOwnedCovering(item.id).owned) + " owned · " + _vm._s(_vm.getDoctorOwnedCovering(item.id).covering) + " covering ")]) : _vm._e(), _vm.getDeltaNote(item.id) ? _c('div', {
          staticClass: "text-small tw-mt-0.5",
          class: _vm.getDeltaNote(item.id).startsWith('↑') ? 'tw-text-orange-500' : 'tw-text-blue-500'
        }, [_vm._v(" " + _vm._s(_vm.getDeltaNote(item.id)) + " ")]) : _vm._e()]) : _c('span', {
          staticClass: "text-muted"
        }, [_vm._v("—")])];
      }
    }, {
      key: "cell(newTotal)",
      fn: function ({
        item
      }) {
        return [!_vm.selectedIds.includes(item.id) ? _c('span', {
          staticClass: "text-muted"
        }, [_vm._v("—")]) : _c('CoreTooltip', {
          attrs: {
            "placement": "left"
          },
          scopedSlots: _vm._u([{
            key: "popper",
            fn: function () {
              return [_c('div', {
                staticClass: "tw-mb-1 tw-font-bold"
              }, [_vm._v(" " + _vm._s(_vm.getDoctorOwnedCovering(item.id).owned) + " Owned · " + _vm._s(_vm.getDoctorOwnedCovering(item.id).covering) + " Covering ")]), _vm._l(_vm.getStateBreakdown(item.id), function (line) {
                return _c('div', {
                  key: line.state,
                  staticClass: "text-small"
                }, [_vm._v(" " + _vm._s(line.state) + " · " + _vm._s(line.share) + " · " + _vm._s(_vm.getSharingLabel(line.state)) + " ")]);
              })];
            },
            proxy: true
          }], null, true)
        }, [_c('span', [_c('span', {
          staticClass: "tw-text-base tw-font-semibold"
        }, [_vm._v(" " + _vm._s(((_vm.doctorLoads[item.id] || 0) + _vm.getTotalEstimate(item.id)).toLocaleString()) + " ")]), _c('div', {
          staticClass: "text-small tw-mt-1",
          class: _vm.loadPercentClass(item.id)
        }, [_vm._v(" +" + _vm._s(_vm.getTotalEstimate(item.id)) + " (" + _vm._s(_vm.loadPercentLabel(item.id)) + "% of load) ")])])])];
      }
    }, {
      key: "row-details",
      fn: function ({
        item
      }) {
        return [_c('div', {
          staticClass: "tw-py-2 tw-pl-10 tw-pr-4"
        }, _vm._l(_vm.getStateBreakdown(item.id), function (line) {
          return _c('div', {
            key: line.state,
            staticClass: "text-muted text-small"
          }, [_vm._v(" +" + _vm._s(line.share) + " " + _vm._s(line.state) + " (" + _vm._s(line.owned) + " Owned / " + _vm._s(line.covering) + " Covering) ")]);
        }), 0)];
      }
    }])
  })], 1)]), _vm.bannerStatus ? _c('div', {
    staticClass: "banner-box tw-mt-4 tw-shrink-0 tw-rounded tw-p-4",
    class: _vm.bannerStatus.tone === 'success' ? 'banner-success' : 'banner-warning',
    staticStyle: {
      "grid-area": "banner"
    }
  }, [_c('div', {
    staticClass: "tw-flex tw-flex-wrap tw-gap-6 tw-text-sm tw-font-medium"
  }, [_c('span', [_vm._v("Total Number of Patients to Transfer "), _c('strong', [_vm._v(_vm._s(_vm.reduceTargetCount))])]), _c('span', [_vm._v(" Total Number of Patients Assigned "), _c('strong', [_vm._v(_vm._s(_vm.totalDistributed))]), _vm._v(" (" + _vm._s(_vm.totalAssignedOwned) + " owned · " + _vm._s(_vm.totalAssignedCovering) + " covering) ")]), _c('span', [_vm._v("Selected Doctors "), _c('strong', [_vm._v(_vm._s(_vm.selectedIds.length))])])]), _c('div', {
    staticClass: "text-small tw-mt-1"
  }, [_vm._v(_vm._s(_vm.bannerStatus.message))])]) : _vm._e()]], 2);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };